(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dining-table-grid-feature"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dining-table-feature')) {
    customElements.define('dining-table-feature', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video || this.dataset.autoplay !== 'true') return;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onMotion = () => { if (this.motion.matches) this.video.pause(); };
        this.motion.addEventListener('change', this.onMotion);
        this.observer = new IntersectionObserver(entries => {
          if (entries[0].isIntersecting && !this.motion.matches) {
            this.video.play().catch(() => {});
          } else {
            this.video.pause();
          }
        }, { threshold: 0.35 });
        this.observer.observe(this);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.motion?.removeEventListener('change', this.onMotion);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
